"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./style.less");
const ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const material_1 = require("@mui/material");
const react_1 = require("react");
const react_use_1 = require("react-use");
const zustandStore_1 = require("../../../../zustandStore");
const SideMenuHeader = () => {
    const isOpenOnDesktopView = (0, zustandStore_1.useZustand)(state => state.sideMenu.isOpenOnDesktopView ?? true);
    const isOpenOnMobileView = (0, zustandStore_1.useZustand)(state => state.sideMenu.isOpenOnMobileView);
    const { openSideMenuOnDesktopView, openSideMenuOnMobileView } = (0, zustandStore_1.useZustand)();
    const isMobileWidth = (0, react_use_1.useMedia)('(max-width: 650px)');
    const toggleIsSideMenuOpen = (0, react_1.useCallback)((event) => {
        event.preventDefault();
        const headerElement = document.querySelector('.ts-app .ts-headerbar');
        if (isMobileWidth) {
            openSideMenuOnMobileView(false);
        }
        else {
            openSideMenuOnDesktopView(!isOpenOnDesktopView);
        }
        // If the side menu is open we remove the styles(from ts.ui) and class from the header element
        if (headerElement && (isOpenOnMobileView || isOpenOnDesktopView)) {
            headerElement.style.opacity = '1';
            headerElement.classList.remove('_gui-hidden');
        }
        else if (headerElement) {
            headerElement.style.opacity = '0';
            headerElement.classList.add('_gui-hidden');
        }
    }, [isMobileWidth, isOpenOnDesktopView, isOpenOnMobileView, openSideMenuOnDesktopView, openSideMenuOnMobileView]);
    (0, react_1.useEffect)(() => {
        const collapseButton = document.querySelector('.side-menu-header-collapse-button');
        const closeIcon = collapseButton?.querySelector('i.ts-icon-close');
        if (closeIcon) {
            collapseButton?.classList.add('hasCloseIcon');
        }
        else {
            collapseButton?.classList.remove('hasCloseIcon');
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { "ts-variant": isOpenOnDesktopView ? 'sideMenuHeaderPaper' : 'sideMenuHeaderCollapsed', onClick: toggleIsSideMenuOpen, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", "ts-variant": isOpenOnDesktopView ? 'sidebarHeaderIconDiv' : 'sidebarHeaderIconCollapsedDiv', children: isMobileWidth ? (isOpenOnMobileView ? ((0, jsx_runtime_1.jsx)(Close_1.default, { "ts-variant": "mobileCloseIcon", onClick: toggleIsSideMenuOpen })) : ('')) : ((0, jsx_runtime_1.jsx)(ChevronRight_1.default, { color: "inherit", onClick: toggleIsSideMenuOpen, "ts-variant": "sidebarHeaderIcon", className: `${isOpenOnDesktopView ? 'animateLeft' : 'animateRight'}` })) }) }));
};
exports.default = SideMenuHeader;
